import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import salonService from "../../services/SalonService";
import { useSalon } from "../../context/SalonContext";
import GlobalLoader from "../loadingIndicator/GlobalLoader";
import "./LoyaltyWallet.css";

export default function LoyaltyWallet({ salonUuid: propSalonUuid }) {
    const navigate = useNavigate();
    const { salonUuid, customerId } = useSalon();

    const [wallet, setWallet] = useState(null);
    const [config, setConfig] = useState(null);
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);

    const finalSalonUuid = propSalonUuid || salonUuid || localStorage.getItem("SALON_UUID");

    useEffect(() => {
        loadWallet();
    }, []);

    const loadWallet = async () => {
        try {
            const res = await salonService.getCustomerLoyaltyWallet(finalSalonUuid, customerId);
            setWallet(res.data.wallet);
            setConfig(res.data.config);
            setTransactions(res.data.transactions || []);
        } catch (e) {
            console.error("Wallet load failed", e);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    if (loading) return <GlobalLoader />;

    return (
        <div className="loyalty-wallet-container">

            {/* Wallet Card */}
            <div className="wallet-card">
                <h3>⭐ Loyalty Points</h3>

                <div className="points-big">
                    {wallet?.pointsBalance || 0}
                </div>

                <div className="wallet-value">
                    ₹{wallet?.pointsBalance || 0} available
                </div>
            </div>

            {/* Rules */}
            {config && (
                <div className="rules-card">
                    <p>🎁 Earn {config.pointsEarned} for every ₹{config.spendAmount}</p>
                    <p>💸 Redeem up to {config.maxRedeemPercentage}%</p>
                </div>
            )}

            {/* Transactions */}
            <h3 className="section-title">Recent Activity</h3>

            {transactions.length === 0 ? (
                <div className="empty">
                    <p>No transactions yet</p>
                </div>
            ) : (
                <div className="txn-list">
                    {transactions.map((txn) => {
                        const isEarn = txn.transactionType === "EARN";

                        return (
                            <div
                                className="txn-card clickable"
                                key={txn.id}
                                onClick={() => {
                                    if (!txn.apntId) return;

                                    navigate(`/appointment/${txn.apntId}`, {
                                        state: {
                                            apntId: txn.apntId,
                                            salonUuid: finalSalonUuid
                                        }
                                    });
                                }}
                            >
                                <div className="txn-icon">
                                    {isEarn ? "⬇️" : "⬆️"}
                                </div>

                                <div className="txn-details">
                                    <p className="reason">{txn.reason}</p>
                                    <p className="date">{formatDate(txn.createdDate)}</p>
                                </div>

                                <div className={`points ${isEarn ? "earn" : "redeem"}`}>
                                    {/* {isEarn ? "+" : "-"} */}
                                    {txn.points}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}